/* import __COLOCATED_TEMPLATE__ from './saas-shared-ui-shim.hbs.js'; */
import { macroCondition, isTesting, importSync } from '@embroider/macros';
/**
 * Proxy component that switches between real and mock implementations of the SaaS Shared UI Shim.
 * Uses Embroider macros for static build-time resolution.
 *
 * - In test builds: uses mock components from `@squareup/saas-shared-ui/component-mocks`
 * - In production builds: uses real components from `@squareup/saas-shared-ui`
 *
 * Example usage:
 *
 *  <Saas::SaasSharedUiShim
 *    @componentName="MyReactComponent"
 *    @prop1="value1"
 *    @prop2="value2"
 *    @prop3="value3"
 * />
 *
 * Example using a live SaaS component:
 *
 * <Saas::SaasSharedUiShim
 *    @componentName="UpsellPill"
 *    @featureToken="feature-token"
 *    @size="medium"
 *    @shimTag={{ShimTag.DIV}}
 * />
 */

const Impl = macroCondition(isTesting()) ?
// Test build: use mock implementation
importSync('@dashboard/shared-ui/components/saas/mock-saas-shared-ui-shim').default :
// Non-test builds: use real implementation
importSync('@dashboard/shared-ui/components/saas/real-saas-shared-ui-shim').default;
export default Impl;